import React,{ useState,useEffect,forwardRef,useImperativeHandle } from 'react'
import { Modal,Form,Input,Select,message } from 'antd';
import { saveChannel,supplyChannelAppList } from "@/services/channel"
import { ResDataType } from '@/services/ajax';
import { DataType } from '../column';
import usePagAndCommon from '@/hooks/usePagAndCommon';
interface channelAppItemType {
    id:number,
    name:string
}
const ChannelContent = (props:any,ref:any) => {
    const { save } = props;
    const { curType,setCurType,isModalOpen,setIsModalOpen } = usePagAndCommon();
    const [form] = Form.useForm();
    const [curChannel,setCurChannel] = useState<DataType>();
    const [channelAppList,setChannelAppList] = useState<channelAppItemType[]>([]);

    const getSupplyChannelAppList = async () => {
        const res = await supplyChannelAppList() as ResDataType;
        if (res.code == 0) {
            setChannelAppList(res.data.list.map((ite:channelAppItemType)=>{
                return {value:ite.id,label:ite.name}
            }))
        } else {
            message.error(res.message);
        }
    }
    const showModal = (type:string,row:DataType) => {
        setCurType(type);
        setCurChannel(row);
        form.resetFields();
        getSupplyChannelAppList();
        if(type=='edit') {
            // const {name,remark,supplyChannelAppId} = row;
            form.setFieldsValue(row) 
        }
        setIsModalOpen(true);
    };
    const handleOk = async () => {
        try {
            const values = await form.validateFields();
            const data = {...values,id:curType=='add'? 0 :curChannel?.id};
            const res = await saveChannel(data) as ResDataType; 
            if (res.code == 0) {
                message.success('保存成功');
                setIsModalOpen(false); 
                save();
            }else {
                message.error(res.message);
            }
        } catch (errorInfo) {
            console.log('Failed:', errorInfo); 
        } 
    }
    const handleCancel = () => {
        setIsModalOpen(false);
      };
    const formItem = [{
        name:'name',
        label:'渠道名称',
        required:true,
        requireText:'请输入渠道名称'
    },{
        name:'remark',
        label:'备注',
        required:false,
        requireText:'备注'
    }]

    useImperativeHandle(ref, () => ({
        open: (type:string,row:DataType) => showModal(type,row),
    }))
    return(
        <Modal maskClosable={false} title={curType == 'add'?'新增渠道':'编辑渠道'} okText="确定" cancelText="取消" open={isModalOpen} onOk={handleOk} onCancel={handleCancel} >
            <Form
                form={form}
                labelCol={{ span: 6 }}
                wrapperCol={{ span: 14 }}
                layout="horizontal"
                style={{ maxWidth: 600 }}
                >
                    <Form.Item label="供货渠道应用" name='supplyChannelAppId' rules={[{ required: true, message: '请选择供货渠道应用' }]}>
                        <Select
                            id='value'
                            placeholder="请选择供货渠道应用"
                            options={channelAppList}
                        />
                    </Form.Item>
                    {
                        formItem.map((item)=> {
                            return <Form.Item label={item.label} name={item.name} key={item.name} rules={[{ required: item.required, message: item.requireText }]}>
                                <Input placeholder={item.requireText} /> 
                            </Form.Item>
                        })
                    }
            </Form>
        </Modal>
    )
}

export default forwardRef(ChannelContent)